import { STAKEHOLDERS_LIST } from '../../stakeholdersFields'

import { formatStakeholdersListFromBE } from '../../formatters/stakeholdersListTransformers'
import { COUNTRY_ID } from '../../fields'

export const getInitialValues = sroiInputsPreset => {
  return {
    [COUNTRY_ID]: sroiInputsPreset?.inputs_preset?.[COUNTRY_ID] || '',
    [STAKEHOLDERS_LIST]: formatStakeholdersListFromBE(sroiInputsPreset?.inputs_preset?.[STAKEHOLDERS_LIST]) || []
  }
}
